'use client';

import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
import { type ButtonHTMLAttributes, forwardRef, type MouseEvent } from 'react';
import { useFocusVisible } from 'react-aria';
import { ScoreGauge } from '@shared/ui-components/score-gauge/score-gauge';
import { useMounted } from '@shared/utils/hooks/use-mounted';
import styles from './quiz-tab-item.module.scss';
type QuizTabItemProps = {
  assessmentScore: number;
  buttonProps: ButtonHTMLAttributes<HTMLButtonElement>;
  isActive: boolean;
  onClick?: (event: MouseEvent<HTMLButtonElement>) => void;
  scoreLabel: null | string | undefined;
};
export const QuizTabItem = forwardRef<HTMLButtonElement, QuizTabItemProps>((t0, ref) => {
  const $ = _c(16);
  const {
    assessmentScore,
    buttonProps,
    isActive,
    onClick,
    scoreLabel
  } = t0;
  const isMounted = useMounted();
  const {
    isFocusVisible
  } = useFocusVisible();
  const t1 = scoreLabel ?? undefined;
  const t2 = isMounted && isFocusVisible;
  let t3;
  if ($[0] !== t2) {
    t3 = classNames(styles["quiz-tab-item"], {
      [styles["quiz-tab-item--focus-visible"]]: t2
    });
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== buttonProps || $[3] !== onClick) {
    t4 = event => {
      buttonProps.onClick?.(event);
      onClick?.(event);
    };
    $[2] = buttonProps;
    $[3] = onClick;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== assessmentScore || $[6] !== isActive || $[7] !== scoreLabel) {
    t5 = <ScoreGauge isActive={isActive} isSecondary={true} score={assessmentScore} scoreLabel={scoreLabel} />;
    $[5] = assessmentScore;
    $[6] = isActive;
    $[7] = scoreLabel;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== buttonProps || $[10] !== ref || $[11] !== t1 || $[12] !== t3 || $[13] !== t4 || $[14] !== t5) {
    t6 = <button aria-label={t1} className={t3} ref={ref} type="button" {...buttonProps} onClick={t4}>{t5}</button>;
    $[9] = buttonProps;
    $[10] = ref;
    $[11] = t1;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
});